import React, { useEffect, useRef, useState } from 'react';
import Chart from 'react-apexcharts';
import { createPortal } from 'react-dom';
import useSidebarSubMainTab from '../../../shared/HandleOpenSidebarSubTab/useSidebarSubMainTab';

const DonutChart = ({ type, data: seriesVals }) => {


  // console.log(data:seriesVals,'dataaaaaaaa');

  const [hoveredPoint, setHoveredPoint] = useState(null);
  const [isHovered, setIsHovered] = useState(true);
  const hoverTimer = useRef(null); // Ref to hold the timer ID
  // const dataList = seriesVals.flatMap(item => item.data).flat();
  // const categoriesList = seriesVals.map(item => item.group);
  // const categoriesList = seriesVals.flatMap(item => item.BillingStatus);

  const dataItem = seriesVals[0] || {};
  const dataList = dataItem.data || [];
  const categoriesList = dataItem.BillingStatus || [];


  const legends = {
    categories: categoriesList,
    colors: seriesVals?.ColorCode,
    lebel: seriesVals?.BillingStatus
    // colors : ['var(--orange)', '#EA9A7B', '#33FF57', '#334BFF', '#FF33A6', '#33FFEC', '#FF336C', 'var(--orange)', '#EA9A9B']
  };
  const data = {
    seriesData: dataList,
    labels: type === "Appointments" ? ["Active", "Due", "Schedule", "Blocked"] : categoriesList,
    colors: type === "Appointments" ? ['#7BD57E', '#FCD3AB', '#92ECE5', '#D6E5FF'] :  dataItem.ColorCode || [],
  }
  const initialOptions = {
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false,
            // name: { color: 'red', }, 
            // value: { color: 'red', }, 
          },
        },
      },
    },
    chart: {
      type: 'donut',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
      events: {
        dataPointMouseEnter: function (event, chartContext, config) {
          hoverTimer.current = setTimeout(() => {
            setHoveredPoint({
              position: { X: event.clientX, Y: event.clientY },
              seriesIndex: config.seriesIndex,
              dataPointIndex: config.dataPointIndex,
              w: chartContext.w,
            });
            setIsHovered(true);
          }, 50);
        },
        dataPointMouseLeave: function () {
          clearTimeout(hoverTimer.current); // Cancel the pending timeout
        },
      },
    },
    series: data.seriesData,
    labels: data.labels,
    colors: data.colors,
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    grid: {
      border: '0.25px solid #959595',
    },
    // annotations: {
    //   text: [
    //     {
    //       text: total.toString(),
    //       x: '50%',
    //       y: '50%',
    //       background: '#fffffssf',
    //       borderColor: 'var(--orange)',
    //       borderWidth: 2,
    //       borderRadius: 4,
    //       textAnchor: 'middle',
    //       fontSize: '16px',
    //       offsetY: 0,
    //     },
    //   ],
    // },
    legend: {
      show: type === "Appointments" ? true : true,
      fontSize: 12,
      position: type === "Appointments" ? 'right' : 'bottom',
      // width: 60,
      markers: {
        radius: 1,
        height: 6,
        width: 6,
      },
    },
  };

  const [state, setState] = useState(initialOptions);

  return (
    <>
      <Chart
        options={state}
        series={state.series}
        type={state.chart.type}
        height={type === "Appointments" ? "125" : "228"}
      />
      {hoveredPoint && isHovered && hoveredPoint.seriesIndex !== -1 && (
        createPortal(
          <CustomTooltip
            position={hoveredPoint.position}
            series={state.series}
            seriesIndex={hoveredPoint.seriesIndex}
            dataPointIndex={hoveredPoint.dataPointIndex}
            w={hoveredPoint.w}
            setHoveredPoint={setHoveredPoint}
            isHovered={isHovered}
            setIsHovered={setIsHovered}
            legends={legends}
          // FinancialFilterDateType={FinancialFilterDateType}
          // months={months}
          />,
          document.getElementById('root') // Render to the root
        )
      )}
      {/* {type === "Appointments" ? <></>:
    <div className="d-flex flex-wrap gap-1 charges_legends">
      {seriesVals?.map((_, i) => (
        <p key={i} className="clr_gry_text xxsm_text">
          <span style={{ backgroundColor: legends.colors[i] }}></span> {legends.categories[i]}
        </p>
      ))}
    </div>} */}
    </>
  );
};

export default DonutChart;
const CustomTooltip = ({ position, series, seriesIndex, dataPointIndex, legends, w, setHoveredPoint, isHovered, setIsHovered, FinancialFilterDateType, months }) => {
  const openSidebarSubMainTab = useSidebarSubMainTab();
  const [isOverflowedY, setIsOverflowedY] = useState(false);

  const checkTooltipOverflow = () => {
    const tooltip = document.getElementById('tooltip');
    const rect = tooltip.getBoundingClientRect();
    setIsOverflowedY(rect.bottom > window.innerHeight);
  };

  useEffect(() => {
    checkTooltipOverflow();
    window.addEventListener('resize', checkTooltipOverflow);
    return () => window.removeEventListener('resize', checkTooltipOverflow);
  }, []);

  const seriesData = w.config.series.map((item, index) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2, // minimum number of fractional digits
      maximumFractionDigits: 2, // maximum number of fractional digits
    });
    console.log("first", w.config.labels)
    // Access the data point for the current series
    let amount = item ? formatter.format(item) : formatter.format(0);
    return (
      <div className="d-flex justify-content-between mt-1" style={{ width: '200px' }} key={index}>
        <p className="xsm_text">
          <span
            style={{
              display: 'inline-block',
              backgroundColor: w.globals.colors[index],
              width: '6px',
              height: '6px',
              borderRadius: '3px',
              marginRight: '5px',
            }}
          ></span>
          {legends.categories[index]}
        </p>
        <p className="xsm_text ammount-text cursor-pointer" onClick={() => { handleClose(); openSidebarSubMainTab(`Claims-71-{"BillingStatus":"${w.config.labels[index]}"}`); }}>{amount}</p>
      </div>
    );
  });

  const handleClose = () => {
    setIsHovered(false);
    setHoveredPoint(null);
  }
  return (
    <div
      id="tooltip" className={`apexcharts-tooltip-title  Charges-Not-Billed pt-0 mt-0 ar-apexcharts-theme-light ${isOverflowedY ? 'charges-flipX' : ''} `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => { handleClose(); }}
      style={{
        display: isHovered ? 'block' : 'none', position: 'absolute', // Absolute positioning
        top: `${position.Y - 44}px`,
        left: `${position.X - 44}px `,
        zIndex: "100",
        transition: ".15s ease all",
         opacity: 0,
      }}
    >
      <p class='xsm_heading app_border py-2 text-center border-end-0 border-start-0 border-top-0'>Charges Not Billed</p>
      <div className='content hover-scrollbar za-donut-chart'>{seriesData}</div>
    </div>
  );
};
